import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import photoData from "../data/photos.json";
import { PhotoGallery } from "./components/PhotoGallery";
import { ThemeToggle } from "./components/ThemeToggle";
import { getAppliedTheme } from "./theme";
const data = photoData;
export function App() {
    const initialTheme = getAppliedTheme(document);
    return (_jsxs(_Fragment, { children: [_jsx("header", { className: "navbar gallery-navbar", children: _jsxs("div", { className: "container", children: [_jsx("span", { className: "navbar-brand mb-0 h1", children: "Gallery" }), _jsx(ThemeToggle, { initialTheme: initialTheme })] }) }), _jsxs("main", { className: "container gallery-main", children: [_jsx("h1", { className: "visually-hidden", children: "Personal life-photo gallery" }), _jsx(PhotoGallery, { items: data.items })] })] }));
}
